module.exports = __webpack_public_path__ + "static/img-fork-216f72b89c102ce1fb585aa995f82a70.jpg";